<template>
  <div>
    <Head title="Adsets" />
          <!-- {{ accounts }} -->
          <h1 class="mb-8 text-3xl font-bold">Adsets</h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
        <label class="block text-gray-700">Account Type:</label>
        <!-- <select v-model="form.account" class="form-select mt-1 w-full">
          <option v-for="account in accounts" :key="account.account_id" :value="account.account_id">
            {{ account.name }}
            </option>
        </select> -->
      </search-filter>
    
    </div>


  <!-- <Link
    class="btn-indigo relative flex items-center justify-center"
    href="/post/getcontent"
    :class="{ 'opacity-50 cursor-not-allowed': isDisabled }"
    :disabled="isDisabled"
    @click="handleClick"
  >
    <span v-if="!isLoading">
      <span></span>
      <span class="hidden md:inline">&nbsp;Pull New Posts</span>
    </span>
    <span v-else>
      <svg
        class="animate-spin h-5 w-5 text-white"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          class="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          stroke-width="4"
        ></circle>
        <path
          class="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
        ></path>
      </svg>
    </span>
  </Link> -->

    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6">Adset Name</th>
          <th class="pb-4 pt-6 px-6">Account Name</th>
          <th class="pb-4 pt-6 px-6">campaign Name</th>
          <th class="pb-4 pt-6 px-6">Ad Name</th>
          <th class="pb-4 pt-6 px-6"  @click="toggleSort('status')">Status
            <span v-if="sortColumn === 'status'">
              <span v-if="this.form.sortOrder === 'ACTIVE'">↑</span>
              <span v-else>↓</span>
            </span>
          </th>
          <th class="pb-4 pt-6 px-6"  @click="toggleSort('time')">Created<br> time
            <span v-if="sortColumnTime === 'time'">
              <span v-if="this.form.sortTime === 'desc'">↑</span>
              <span v-else>↓</span>
            </span></th>
          <th class="pb-4 pt-6 px-6">Impressions</th>
          <th class="pb-4 pt-6 px-6">Clicks</th>
          <th class="pb-4 pt-6 px-6">Spend</th>
          <th class="pb-4 pt-6 px-6">Cpc</th>
          <th class="pb-4 pt-6 px-6">Cpm</th>
          <th class="pb-4 pt-6 px-6">Reach</th>
          <th class="pb-4 pt-6 px-6">Cpp</th>
          <th class="pb-4 pt-6 px-6">Website Roas</th>
          <th class="pb-4 pt-6 px-6">Purchase Roas</th>
        </tr>
        <tr v-for="(adset) in adset.data" :key="adset.adset_id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <!-- <td class="border-t px-6 py-4" >
            <a  v-if="content.media && content.media.shortcode" 
              class="flex items-center px-6 py-4 highlight-link" 
              :href="content.cntnt_url" 
              target="_blank">
              {{ content.cntnt_shortcode }}
            </a>
             <span v-else class="flex items-center px-6 py-4" >
              {{ content.cntnt_shortcode }}
             </span>
          </td> -->
       
          <td class="border-t">
        <span 
          class="flex items-center px-6 py-4"  
          :title="adset.name" 
          tabindex="-1"
        >
          {{ truncatedName(adset.name) }}
        </span>
      </td>
      <td class="border-t">
        <span 
          class="flex items-center px-6 py-4" 
          :title="adset.campaign[0].ad_account.name || 'N/A'" 
          tabindex="-1"
        >
        {{ truncatedName(adset.campaign[0].ad_account.name)  }}
        </span>
      </td>
      <td class="border-t">
        <a 
          v-if="adset.campaign && adset.campaign[0] && adset.campaign[0].name" 
          :href="`/campaign?campaign_id=${adset.campaign[0].campaign_id}`" 
          class="flex items-center px-6 py-4 max-w-full bg-blue-300 overflow-hidden text-ellipsis whitespace-nowrap"
          :title="adset.campaign[0].name"
          tabindex="-1"
        >
          {{ truncatedName(adset.campaign[0].name) }}
        </a>
        <span 
          v-else 
          class="flex items-center px-6 py-4 max-w-full overflow-hidden text-ellipsis whitespace-nowrap text-gray-400"
        >
           N/A
        </span>
      </td>
      
        <!-- <td class="border-t">
            <span class="flex items-center px-6 py-4"   :title="adset.campaign[0].name|| 'N/A'" tabindex="-1">
                {{ truncatedName(adset.campaign[0].name) }}
            </span>
        </td> -->


        <td class="border-t">
        <a 
          v-if="adset.ads && adset.ads[0] && adset.ads[0].name" 
          :href="`/ads?adset_id=${adset.adset_id}`" 
          class="flex items-center px-6 py-4 max-w-full bg-blue-300 overflow-hidden text-ellipsis whitespace-nowrap"
          :title="adset.ads[0].name"
          tabindex="-1"
        >
          {{ truncatedName(adset.ads[0].name) }}
        </a>
        <span 
          v-else 
          class="flex items-center px-6 py-4 max-w-full overflow-hidden text-ellipsis whitespace-nowrap text-gray-400"
        >
           N/A
        </span>
      </td>
        <td class="w-px border-t">
            <span class="flex items-center px-4" tabindex="-1">
                <span v-if="adset.status">{{ adset.status }}</span>
                <span v-else>N/A</span>
            </span>
        </td>
        <td class="w-px border-t">
            <span class="flex items-center px-4" tabindex="-1">
                <span v-if="adset.created_time">{{ adset.created_time }}</span>
                <span v-else>N/A</span>
            </span>
        </td>
        <td class="w-px border-t">
            <span class="flex items-center px-4" tabindex="-1">
                <span v-if="adset.impressions">{{ adset.impressions }}</span>
                <span v-else>N/A</span>
            </span>
        </td>
        <td class="w-px border-t">
            <span class="flex items-center px-4" tabindex="-1">
                <span v-if="adset.clicks">{{ adset.clicks }}</span>
                <span v-else>N/A</span>
            </span>
        </td>
        <td class="w-px border-t">
            <span class="flex items-center px-4" tabindex="-1">
                <span v-if="adset.spend">{{ adset.spend }}</span>
                <span v-else>N/A</span>
            </span>
        </td>
        <td class="w-px border-t">
            <span class="flex items-center px-4" tabindex="-1">
                <span v-if="adset.cpc">{{ adset.cpc }}</span>
                <span v-else>N/A</span>
            </span>
        </td>
        <td class="w-px border-t">
            <span class="flex items-center px-4" tabindex="-1">
                <span v-if="adset.cpm">{{ adset.cpm }}</span>
                <span v-else>N/A</span>
            </span>
        </td>
        <td class="w-px border-t">
            <span class="flex items-center px-4" tabindex="-1">
                <span v-if="adset.reach">{{ adset.reach }}</span>
                <span v-else>N/A</span>
            </span>
        </td>
        <td class="w-px border-t">
            <span class="flex items-center px-4" tabindex="-1">
                <span v-if="adset.cpp">{{ adset.cpp }}</span>
                <span v-else>N/A</span>
            </span>
        </td>
        <td class="w-px border-t">
            <span class="flex items-center px-4" tabindex="-1">
                <span v-if="adset.website_purchase_roas">{{ adset.website_purchase_roas }}</span>
                <span v-else>N/A</span>
            </span>
        </td>
        <td class="w-px border-t">
            <span class="flex items-center px-4" tabindex="-1">
                <span v-if="adset.purchase_roas">{{ adset.purchase_roas }}</span>
                <span v-else>N/A</span>
            </span>
        </td>

          <!-- <td class="w-px border-t">
              <span class="flex items-center px-4"  tabindex="-1">  {{ adset.date_stop }}</span>
          </td> -->
          <!-- Action Icon -->
          <!-- <td class="w-px border-t">
              <Link class="flex items-center px-4" :href="`/post/${content.cntnt_id}/edit`" tabindex="-1">
                  <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
              </Link>
          </td> -->
      </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="adset.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/Search'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    adset: Object,
    campaign: Array,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        account: this.filters.account,
        sortOrder: this.filters.sortOrder,
        sortTime: this.filters.sortTime,
      },
      isDisabled: false,
      isLoading: false,
      sortColumn: 'status', 
      sortColumnTime: 'time', 

    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('adset', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    toggleSort(column) {
        // If the same column is clicked again, toggle the order
        if (column == 'status' &&  this.sortColumn === 'status') {
          this.form.sortOrder = this.form.sortOrder === 'PAUSED' ? 'ACTIVE' : 'PAUSED';
        }
        if (column == 'time' && this.sortColumnTime === 'time') {
          this.form.sortTime = this.form.sortTime === 'asc' ? 'desc' : 'asc';
        } 
    },
    truncatedName(text) {
      const maxLength = 40;
      const name = text || '';
      return name.length > maxLength ? name.substring(0, maxLength) + '...' : name;
    },
  },
  
} 
</script>
<style scoped>
.bg-blue-300 {
  color: rgb(115, 115, 206);
}
.bg-blue-300:hover{
  color: blue;
}
</style>